import axios from 'axios';
import { developerCanceler } from '@/models';
export function isArray(val) {
  return Object.prototype.toString.call(val) === '[object Array]';
}
export function isObject(val) {
  return Object.prototype.toString.call(val) === '[object Object]';
}
export function isString(val) {
  return Object.prototype.toString.call(val) === '[object String]';
}
export const isSSR = function () {
  try {
    return !(typeof window !== 'undefined' && document !== undefined);
  } catch (e) {
    return true;
  }
}();

// 请求是否是主动取消的
export const isDeveloperCancel = error => !!(axios.isCancel(error) && error?.message === developerCanceler);